<div class="detail-container">
  <ng-container *ngIf="!loading; else loadingContainer">
    <div *ngFor="let item of items">
      <div class="d-flex">
        <ng-container *ngIf="item.subProject != null">
          <app-atelier-sub-project-view
            class="w-100"
            [item]="item"
            [selectedItemId]="selectedItemId"
            (selectedItemIdEmitter)="updateSelectedItem($event)"
          ></app-atelier-sub-project-view>
        </ng-container>
        <ng-container *ngIf="item.immoTask != null">
          <app-atelier-immo-task-view
            class="w-100"
            [item]="item"
            [selectedItemId]="selectedItemId"
            (selectedItemIdEmitter)="updateSelectedItem($event)"
          ></app-atelier-immo-task-view>
        </ng-container>
      </div>

      <atelier-item-detail
        *ngIf="item.id === selectedItemId && item.subProject != null"
        class="item-detail"
        [item]="item"
        [reviewingUserId]="reviewingUserId"
        [atelierUserId]="atelierUserId"
        (checkUpdate)="onCheckUpdate($event)"
        (stockUpdate)="onStockUpdate($event)"
      >
      </atelier-item-detail>

      <atelier-task-item-detail
        *ngIf="item.id === selectedItemId && item.immoTask != null"
        class="item-detail"
        [item]="item"
        [reviewingUserId]="reviewingUserId"
        [atelierUserId]="atelierUserId"
        (checkUpdate)="onCheckUpdate($event)"
      >
      </atelier-task-item-detail>
    </div>
  </ng-container>
  <ng-template #loadingContainer>
    <div style="align-self: center">
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>
  </ng-template>
</div>
